import { Box, Typography } from "@mui/material";

import Marquee from "../../components/ui/Marquee";

const partnerLogos = [
  {
    name: "Al Ahly",
    src: "https://cdn.prod.website-files.com/674fa7a7386e9849d64aca65/676cadbcc4c731918ff4ec4b_Al%20Ahly.png",
    alt: "Al Ahly logo",
  },
  {
    name: "Al Nassr",
    src: "https://cdn.prod.website-files.com/674fa7a7386e9849d64aca65/676cadbc478212b31614f52a_Al%20Nassr.png",
    alt: "Al Nassr logo",
  },
  {
    name: "Zamalek",
    src: "https://cdn.prod.website-files.com/674fa7a7386e9849d64aca65/676cadbcc40debbca977d6f0_Zamalek.png",
    alt: "Zamalek logo",
  },
  {
    name: "ES Tunis",
    src: "https://cdn.prod.website-files.com/674fa7a7386e9849d64aca65/676cadbc5e0e0e8e113f4ab4_ES%20Tunis.png",
    alt: "ES Tunis logo",
  },
  {
    name: "Wadi Degla",
    src: "https://cdn.prod.website-files.com/674fa7a7386e9849d64aca65/676cadbce9235e2e78a0b6e7_Wadi%20Degla.png",
    alt: "Wadi Degla logo",
  },
  {
    name: "Smouha",
    src: "https://cdn.prod.website-files.com/674fa7a7386e9849d64aca65/676cadbc8405e4e41fe632af_Smouha.png",
    alt: "Smouha logo",
  },
];

const PartnerMarquee = () => {
  const marqueeItems = partnerLogos.map((logo) => (
    <Box key={logo.name} sx={styles.logoContainer}>
      <Box component="img" src={logo.src} alt={logo.alt} loading="lazy" sx={styles.logoImage} />
    </Box>
  ));

  return (
    <Box component="section" sx={styles.section}>
      <Typography variant="h2" component="h2" sx={styles.title}>
        We&apos;re partners
      </Typography>
      <Typography variant="h6" component="p" sx={styles.subtitle}>
        We proudly join forces with leading clubs to build stronger opportunities for football talent across the region.
      </Typography>
      <Box sx={styles.marqueeWrapper}>
        <Marquee items={marqueeItems} />
      </Box>
    </Box>
  );
};

export default PartnerMarquee;

const styles = {
  section: {
    py: { xs: 6, md: 8 },
    px: { xs: 3, md: 6 },
    color: "#fff",
    fontFamily: "Montserrat, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
  },
  title: {
    fontSize: { xs: "2rem", md: "3rem", lg: "3.5rem" },
    fontWeight: 700,
    letterSpacing: "0.05em",
    textTransform: "uppercase" as const,
    textAlign: "center",
    color: "#fff",
    mb: { xs: 1, md: 1.5 },
  },
  subtitle: {
    fontSize: { xs: "1rem", md: "1.25rem", lg: "1.375rem" },
    color: "rgba(255,255,255,0.95)",
    fontWeight: 400,
    maxWidth: { xs: "100%", md: 600, lg: 700 },
    textAlign: "center",
    lineHeight: 1.6,
  },
  marqueeWrapper: {
    mt: 5,
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    minWidth: 120,
  },
  logoImage: {
    height: { xs: 38, md: 60 },
    width: "auto",
    filter: "drop-shadow(0 4px 15px rgba(2, 6, 23, 0.45))",
  },
};
